"use strict";
import { __exports as u } from "./index.es455.js";
import { __require as M } from "./index.es294.js";
import { __require as b } from "./index.es456.js";
var i;
function y() {
  return i ? u : (i = 1, (function(c) {
    Object.defineProperty(c, "__esModule", {
      value: !0
    }), Object.defineProperty(c, "getRouteMatcher", {
      enumerable: !0,
      get: function() {
        return l;
      }
    });
    const s = M(), f = b();
    function l(p) {
      let { re: _, groups: d } = p;
      const h = (m) => {
        const n = _.exec(m);
        if (!n) return !1;
        const a = (e) => {
          try {
            return decodeURIComponent(e);
          } catch {
            throw Object.defineProperty(new s.DecodeError("failed to decode param"), "__NEXT_ERROR_CODE", {
              value: "E528",
              enumerable: !1,
              configurable: !0
            });
          }
        }, r = {};
        for (const [e, t] of Object.entries(d)) {
          const o = n[t.pos];
          o !== void 0 && (t.repeat ? r[e] = o.split("/").map((R) => a(R)) : r[e] = a(o));
        }
        return r;
      };
      return (0, f.safeRouteMatcher)(h);
    }
  })(u), u);
}
export {
  y as __require
};
//# sourceMappingURL=index.es383.js.map
